<script type="text/babel">
/* eslint-disable */
import { mapGetters, mapActions } from 'vuex';
import DragAndDropMixin from '@/mixins/DragAndDropMixin.vue';

export default {
    name: 'RenderedTemplate',
    props: {
        // Checker flag for adding event listeners to elements
        eventListeners: {
            type: Boolean,
            default: true
        },
        // Flag for rendering either a preview or a actual edited layout
        preview: {
            type: Boolean,
            default: false
        },
        // Layout with lowered dimensions for preview
        layout: {
            type: Object,
            default: () => { return {} }
        }
    },
    mixins: [DragAndDropMixin],
    computed: {
        ...mapGetters({
            currentLayout : 'getCurrentLayout'
        }),
    },
    methods: {
        ...mapActions(['updateEditedElementAction']),
        /**
         * @function renderSchema
         * @description Rendering function for JSON Schemas
         * @param {function} createElement - CreateElement function passed form Vue.render
         * @param {object} element - Current DOM element (described in schema) from schema
         * @param {string} path - Path passed in recurrency to keep track of element's object path
         * @param {boolean} initial - Flag containing information wheter to add 'children' to the beginning of path
         * */
        renderSchema ({createElement, element, path, initial}) {
            let children;
            let tempPathSet = false;
            let tempPath = `${path}`;
            let {attrs} = element;
            if(attrs) {
                let {style} = attrs;
                if(style) {
                    if(style['background-image']) {
                        // element.attrs.style['background-image'] = element.attrs.style['background-image'].replace("http://coldstorage:1337", `${this.$http.defaults.baseURL}/coldstorage`);
                    }
                }
            }
    
            if(element.children) {
                tempPathSet = true;
                path = initial ? 'children' : `${path}.children`;
                children = [
                    ...element.children.map((child, index) =>
                        this.renderSchema({
                            createElement,
                            element: child,
                            path: `${path}.${index}`,
                            initial: false
                        })
                    ),
                    element.value
                ];
            } else {
                children = element.value;
            }
            return createElement(element.tag, {
                ...element.attrs,
                on: this.eventListeners
                    ? this.attachListeners(element, tempPathSet ? tempPath : path)
                    : {}
            }, children);
        },
        /**
         * @function attachListeners
         * @description Rendering function for JSON Schemas
         * @param {object} element - Current DOM element to be created
         * @param {string} path - Path passed in recurrency to keep track of element's object path
         * */
        attachListeners (element, path) {
            let vm = this;
            return { // Conditionally attaching eventListeners
                click(e) {
                    e.stopPropagation();
                    vm.updateEditedElementAction({element: element, path: path});
                },
                dragstart: (e) => vm.dragstart_handler(e, element, path),
                drag: (e) => this.dragover_handler(e),
                dragover: (e) => this.dragover_handler(e, path),
                drop: (e) => this.drop_handler(e, path),
                dragend: (e) => this.dragend_handler(e)
            }
        }
    },
    render (createElement) {
        return this.renderSchema({
            createElement,
            element: this.preview ? this.layout : this.currentLayout,
            path: '',
            initial: true,
            plainPath: ''
        });
    },
    created () {
        this.$watch('currentLayout', () => {
            this.$forceUpdate();
        }, {
            deep: true
        });
    }
};

</script>

<style lang="scss" scoped>
    .activeElement {
        border: 10px solid;
        @include color('border-color', primary);
    }
</style>
